"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
// kudos: https://usehooks.com/
var useHoverDirty = function (ref) {
    if (process.env.NODE_ENV !== 'production') {
        if ((typeof ref !== 'object') || (typeof ref.current === 'undefined')) {
            throw new TypeError('useHoverDirty expects a single ref argument.');
        }
    }
    var _a = react_1.useState(false), value = _a[0], setValue = _a[1];
    react_1.useEffect(function () {
        var onMouseOver = function () { return setValue(true); };
        var onMouseOut = function () { return setValue(false); };
        if (ref && ref.current) {
            ref.current.addEventListener('mouseover', onMouseOver);
            ref.current.addEventListener('mouseout', onMouseOut);
        }
        return function () {
            if (ref && ref.current) {
                ref.current.removeEventListener('mouseover', onMouseOver);
                ref.current.removeEventListener('mouseout', onMouseOut);
            }
        };
    }, []);
    return value;
};
exports.default = useHoverDirty;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/lib/useHoverDirty.js
// module id = 1202
// module chunks = 17